import { useState, useEffect } from 'react';
import {
  Alert,
  Snackbar,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import { CheckCircle, Error as ErrorIcon } from '@mui/icons-material';
import { formatApiError } from '@/services/api/apiHelpers';
import { themeColors } from '../../../theme/theme';
import { useTranslation } from '@/kit/useTranslation';

export default function WalletStatusMessages({ status, error }) {
  const { t } = useTranslation();
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  useEffect(() => {
    if (status) {
      setSuccessOpen(true);
    }
  }, [status]);

  useEffect(() => {
    if (error) {
      setErrorOpen(true);
    }
  }, [error]);

  return (
    <>
      {/* Success Dialog */}
      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
            maxWidth: 400,
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center">
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                bgcolor: `${themeColors.primaryColor}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CheckCircle
                sx={{
                  fontSize: 40,
                  color: themeColors.primaryColor,
                }}
              />
            </Box>
            <Typography variant="h6" fontWeight={700} textAlign="center">
              {t('payment.wallet.paymentSuccessful')}
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {t('payment.wallet.walletUpdated')}
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button
            onClick={() => setSuccessOpen(false)}
            variant="contained"
            sx={{
              borderRadius: 2,
              px: 4,
              bgcolor: themeColors.primaryColor,
              '&:hover': {
                bgcolor: themeColors.primaryColorDark,
              },
            }}
          >
            {t('payment.gotIt')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Snackbar */}
      <Snackbar
        open={errorOpen}
        autoHideDuration={6000}
        onClose={() => setErrorOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setErrorOpen(false)}
          severity="error"
          variant="filled"
          icon={<ErrorIcon />}
          sx={{
            width: '100%',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          {formatApiError(error)}
        </Alert>
      </Snackbar>
    </>
  );
}
